import { create } from 'zustand'

interface DialogStore {
  isOpen: boolean
  openDialog: () => void
  closeDialog: () => void
}

export const useBillingDialogStore = create<DialogStore>((set) => ({
  isOpen: false,
  openDialog: () => set({ isOpen: true }),
  closeDialog: () => set({ isOpen: false }),
}))
